export const getMinCreationDateHandler = (prevChanges: any[]): Date | undefined => {
  if (prevChanges.length && prevChanges[0]?.changeDate) {
    return new Date(new Date(prevChanges[0].changeDate).getTime() + 86400000);
  }

  return undefined;
}
